// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/AskV2RightRail.test.tsx
import { type TicketMessageCitation } from "@mg/schemas/src/commons/ticket";
import { Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { AskV2RailSubsection } from "./AskV2RailSubsection";

import { CitedClaimsPanel } from "../../components/ask-puntt-cited-claims";

type AskV2RailRelatedClaimsProps = {
  /** Rules the registry matched that the answer did not cite. */
  related: TicketMessageCitation[];
  /** The highest number a cited card can carry, so related cards continue past it. */
  citedCount: number;
};

/**
 * The registry's nearest rows that only fill the citation panel, kept apart
 * from the claims the answer cited.
 */
export function AskV2RailRelatedClaims({
  related,
  citedCount,
}: AskV2RailRelatedClaimsProps) {
  const { t } = useTranslation("ui");
  if (related.length === 0) return null;
  const title = t("askV2.rail.relatedClaims", { count: related.length });
  return (
    // why: these are the registry's nearest rows, not the answer's evidence;
    // under "Cited claims" they read as citations (epic chat 6abe9b8b: 7 of 12
    // were not).
    <AskV2RailSubsection id="related-claims" title={title} defaultOpen={false}>
      <div data-testid="ask-v2-rail-related-claims">
        <Text as="p" size="1" className="mb-2 text-puntt-neutral-gray-11">
          {t("askV2.rail.relatedClaimsExplainer")}
        </Text>
        <CitedClaimsPanel
          citations={related}
          variant="section"
          testIdPrefix="ask-v2-rail-related-claims"
          title={title}
          hideTitle
          // The cited cards hold 1..n, matching the answer's [n] markers;
          // related ones continue the count.
          firstNumber={citedCount + 1}
        />
      </div>
    </AskV2RailSubsection>
  );
}
